import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Build marker — bump this whenever you need a fresh bundle hash to bust
// stale browser caches. Assigned to window so it survives minification.
const BUILD_ID = '2026-07-07.1';
(window as unknown as { __BUILD__: string }).__BUILD__ = BUILD_ID;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
